import { Space, Form, Input, Button, Select, Card } from "antd";
import { SearchOutlined, ReloadOutlined,DownloadOutlined,PlusOutlined } from "@ant-design/icons";
import service from "../../../@services";
import { useEffect, useState } from "react";
import useAddBrand from "../hooks/useAddBrand";
import BrandPageTable from "./components/BrandPageTable";
import AuthComponent from "../../../components/AuthComponent";
import * as Utils from '../../../@utils'
export default function Brand(props) {
  const [form] = Form.useForm();
  const [selectedRowKeys, onSelectChange] = useState([])
  const [loading, setLoading] = useState(false)
  const [tableData, setTableData] = useState({})
  const { addBrand } = useAddBrand();
  useEffect(() => {
    onSearch()
  }, []);
  const onSearch = ({pageIndex=1, pageSize=10} = {}) => {
    const pagination = {pageIndex: pageIndex, pageSize: pageSize}
    const params = Object.assign({},form.getFieldsValue(),pagination)
    fetchData(params)
  }
  const fetchData = async (params) => {
    setLoading(true)
    const data = await service.brand.getBrandPageList(params)
    setLoading(false)
    if(data){
      setTableData(data)
    }
  }
  const onReset = () => {
    form.resetFields();
  };
  const exportBrand = async () => {
    const params = Object.assign({},form.getFieldsValue())
    const file = await service.brand.exportBrand(params)
    const filename = '商品品牌报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  };
  
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <Space
      direction="vertical"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <Card>
        <Form
          form={form}
          layout="inline"
        >
          <Form.Item name="id" label="品牌编码">
            <Input style={{ width: 200 }} placeholder="请输入" />
          </Form.Item>
          <Form.Item name="name" label="品牌名称">
            <Input style={{ width: 200 }} placeholder="请输入" />
          </Form.Item>
          <Form.Item name="status" label="状态">
            <Select style={{ width: 200 }} placeholder="全部">
              <Select.Option value="">全部</Select.Option>
              <Select.Option value={1}>已启用</Select.Option>
              <Select.Option value={0}>已禁用</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/brand/page">
              <Button type="primary" ghost icon={<SearchOutlined />} onClick={onSearch}>查询</Button>
            </AuthComponent>
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/brand/page">
              <Button type="primary" ghost icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
            </AuthComponent>
          </Form.Item>
        </Form>
      </Card>
      <Card style={{ height: "100%", flexGrow: 1 }}>
        <Space style={{ display: "flex", padding: "15px 0", marginTop: "-24px" }}>
          <AuthComponent authKey="/brand/export">
            <Button type="primary" icon={<DownloadOutlined />} onClick={exportBrand}>导出</Button>
          </AuthComponent>
          <AuthComponent authKey="/brand/create">
            <Button type="primary" icon={<PlusOutlined />} onClick={()=>{addBrand().then(()=>onSearch())}}>新增</Button>
          </AuthComponent>
        </Space>
        <BrandPageTable 
          dataSource={tableData}
          rowSelection={rowSelection}
          loading={loading}
          editBrand={(record)=>{addBrand(record).then(()=>onSearch())}}
          handleTableChange={onSearch} />
      </Card>
    </Space>
  );
}
